import Content from "components/Content";
import text from "constants/text";
import Image from "next/image";
import React, { FC, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

import Label from "components/Label";
import styles from "./styles.module.scss";

const TheHHDifference: FC = () => {
  const { title, image, items } = text.vendors.the_humming_homes_difference;
  const [selectedItem, setSelectedItem] = useState<number | null>(0);

  const handleLabelClick = (i: number) => {
    if (i === selectedItem) {
      setSelectedItem(null);
    } else {
      setSelectedItem(i);
    }
  };

  return (
    <div className={styles.parent}>
      <Content
        contentClassName={styles.container}
        containerClassName={styles.wrapper}
      >
        <Label
          variant="h-centered"
          color="lightPrimary"
          className={styles.title}
        >
          {title}
        </Label>
        <div className={styles.content}>
          <div className={styles.image}>
            <Image alt="" src={image} layout="fill" objectFit="cover" />
          </div>
          <div>
            <div className={styles.items}>
              {items.map(({ title: iTitle, description }, i) => (
                <div className={styles.item}>
                  <AnimatePresence>
                    <button
                      className={styles.expandButton}
                      aria-expanded={i === selectedItem}
                      aria-controls="step_description"
                      aria-label={`Show more info about our value: ${iTitle}`}
                      type="button"
                      onClick={() => handleLabelClick(i)}
                    >
                      <Image
                        alt=""
                        src="/caret-down.png"
                        width={16}
                        height={16}
                        className={
                          i === selectedItem ? styles.selectedCaret : undefined
                        }
                      />
                      <Label
                        color="primary"
                        variant="h"
                        className={styles.iTitle}
                        id="value_title"
                      >
                        {iTitle}
                      </Label>
                    </button>
                    {i === selectedItem && (
                      <motion.div
                        initial={{ height: 0 }}
                        exit={{ height: 0 }}
                        animate={{ height: "auto" }}
                      >
                        <div style={{ height: "auto" }} id="step_description">
                          <Label
                            variant="s"
                            color="primary"
                            className={styles.description}
                          >
                            {description}
                          </Label>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Content>
    </div>
  );
};

export default TheHHDifference;
